import { render, staticRenderFns } from "./myRamadanListContent.vue?vue&type=template&id=6b3e637d&scoped=true"
import script from "./myRamadanListContent.vue?vue&type=script&lang=js"
export * from "./myRamadanListContent.vue?vue&type=script&lang=js"
import style0 from "./myRamadanListContent.vue?vue&type=style&index=0&id=6b3e637d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e637d",
  null
  
)

export default component.exports